/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ConfirmNewEmailChangeDataParser = 
/* #__PURE__ */ parsers.object([['code', codecString]]);
export class ConfirmNewEmailChangeData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ConfirmNewEmailChangeDataParser.decode(input).map(res => new ConfirmNewEmailChangeData(res));
    }
    static unsafeDecode(input) {
        return ConfirmNewEmailChangeData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ConfirmNewEmailChangeDataParser.encode(data);
    }
    static schema() {
        return ConfirmNewEmailChangeDataParser.schema();
    }
}
